// extracted by mini-css-extract-plugin
export var adjustAmountButton = "incrementDecrementButtons-module--adjustAmountButton--6b4bd";
export var decrementText = "incrementDecrementButtons-module--decrementText--48c02";
export var disabled = "incrementDecrementButtons-module--disabled--97fe5";
export var incrementDecrementSupplimentaryText = "incrementDecrementButtons-module--increment-decrement-supplimentary-text--95f37";
export var incrementText = "incrementDecrementButtons-module--incrementText--764da";
export var quantityInput = "incrementDecrementButtons-module--quantityInput--a547f";
export var totalSelector = "incrementDecrementButtons-module--totalSelector--29a23";
export var xl = "incrementDecrementButtons-module--xl--a9449";